import { render } from "./MarqueeText.vue?vue&type=template&id=0ef4bd36&ts=true"
import script from "./MarqueeText.vue?vue&type=script&lang=ts"
export * from "./MarqueeText.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__